<form class="text-bidit-primary" #leadForm="ngForm" (ngSubmit)="saveProject(leadForm)">
  <div class=" row-cols-2">
    <div *ngIf="project.quote_ID==null" class="form-inline form-group">
      <span class="warning">* </span>
      <label for="customer_BusinessName" i18n>Customer Name</label>
      <input type="text" name="customer_BusinessName" id="customer_BusinessName"
             class="form-control"
             autocomplete="nope"
             required=""
             matInput
             [formControl]="customerControl"
             [matAutocomplete]="customerAuto"
             [attr.disabled]="readOnly ? '' : null" />
      <mat-autocomplete autoActiveFirstOption #customerAuto="matAutocomplete">
        <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer.customer_BusinessName">{{customer.customer_BusinessName}}</mat-option>
      </mat-autocomplete>
      <div [hidden]="!leadForm.submitted || customerControl.valid"
           class="alert alert-danger" i18n>Customer Required</div>
    </div>
    <div *ngIf="project.quote_ID" class="form-inline form-group">
      <span class="warning">* </span>
      <label for="customer_BusinessName" i18n>Customer Name</label>
      <select name="customer_ID" id="customer_ID"
              class="form-control select-bidit"
              required=""
              [attr.disabled]="readOnly ? '' : null"
              (change)="refreshCustomer()"
              [(ngModel)]="project.customer_ID" #customer_ID="ngModel">
        <option *ngFor="let customer of customers" [value]="customer.customer_ID">{{customer.customer_BusinessName}}</option>
      </select>
      <div [hidden]="!leadForm.submitted || customerControl.valid"
           class="alert alert-danger" i18n>Customer Required</div>
    </div>
    <div class="form-group">
      <span class="warning">* </span>
      <label for="customerType_ID" i18n>Customer Type</label>
      <select name="customerType_ID" id="customerType_ID"
              required
              [attr.disabled]="readOnly ? '' : null"
              class="form-control select-bidit"
              [(ngModel)]="project.customer.customerType_ID" #customerType_ID="ngModel">
        <option [ngValue]="undefined">-</option>
        <option *ngFor="let customerType of customerTypes" [ngValue]="customerType.customerType_ID">{{customerType.customerType_Desc}}</option>
      </select>
      <div [hidden]="!leadForm.submitted || customerType_ID.valid"
           class="alert alert-danger" i18n>Enter a customer type</div>
    </div>
  </div>
  <div *ngIf="project.quote_IsLead==false">
    <div *ngIf="project.quote_ID==null" class="form-group row">
      <div class="col-sm-12 form-inline">
        <div class="control-wrapper">
          <label for="quoteTemplateID" class="col-form-label" i18n>Use Template</label>
          <select name="quoteTemplateID" id="quoteTemplateID" type="text"
                  class="form-control select-bidit"
                  [attr.disabled]="readOnly ? '' : null"
                  maxlength="50"
                  [(ngModel)]="project.quoteTemplateID" #quoteTemplateID="ngModel">
            <option [ngValue]="undefined">-</option>
            <option *ngFor="let quoteTemplate of quoteTemplates" [ngValue]="quoteTemplate.quote_ID">{{quoteTemplate.quote_Name}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="project.quote_IsLead">
    <label for="customer_ID" class=" col-form-label" i18n>Customer Address</label>
    <div class="form-group form-inline row-cols-2">
      <div>
        <input type="text" name="customer_Address1" id="customer_Address1"
               class="form-control" style="width: 95%;"
               [attr.disabled]="readOnly ? '' : null"
               placeholder="Address 1"
               [(ngModel)]="project.customer.customer_Address1" #customer_Address1="ngModel" />
      </div>
      <div>
        <input type="text" name="customer_Address2" id="customer_Address2"
               class="form-control" style="width: 95%"
               placeholder="Address 2"
               [attr.disabled]="readOnly ? '' : null"
               [(ngModel)]="project.customer.customer_Address2" #customer_Address2="ngModel" />
      </div>
    </div>
    <div class="form-group form-inline row-cols-3">
      <div>
        <input type="text" name="customer_City" id="customer_City"
               class="form-control" style="width: 95%;"
               placeholder="City"
               [attr.disabled]="readOnly ? '' : null"
               [(ngModel)]="project.customer.customer_City" #customer_City="ngModel" />
      </div>
      <div style="width: 115px;">
        <select name="customer_State" id="customer_State"
                class="form-control state-select select-bidit"
                [attr.disabled]="readOnly ? '' : null"
                [(ngModel)]="project.customer.customer_State" #customer_State="ngModel">
          <option value="">-</option>
          <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
        </select>
      </div>
      <div>
        <input type="text" name="customer_Postal" id="customer_Postal"
               class="form-control" style="width: 95%;"
               placeholder="Zip"
               [attr.disabled]="readOnly ? '' : null"
               [(ngModel)]="project.customer.customer_Postal" #customer_Postal="ngModel" />
      </div>
    </div>
  </div>
  <div *ngIf="!project.quote_IsLead">
    <label for="customer_ID" class=" col-form-label" i18n>Customer Address</label>
    <div class="form-group form-inline row-cols-2">
      <div class="form-inline">
        <span class="warning">* </span>
        <input type="text" name="customer_Address1" id="customer_Address1"
               class="form-control" style="width: 95%;"
               [attr.disabled]="readOnly ? '' : null"
               placeholder="Address 1"
               required=""
               [(ngModel)]="project.customer.customer_Address1" #customer_Address1="ngModel" />
      </div>
      <div>
        <input type="text" name="customer_Address2" id="customer_Address2"
               class="form-control" style="width: 95%"
               placeholder="Address 2"
               [attr.disabled]="readOnly ? '' : null"
               [(ngModel)]="project.customer.customer_Address2" #customer_Address2="ngModel" />
      </div>
    </div>
    <div class="form-group form-inline row-cols-3">
      <div class="control-wrapper d-flex">
        <span class="warning">* </span>
        <input type="text" name="customer_City" id="customer_City"
               class="form-control" style="width: 95%;"
               placeholder="City"
               [attr.disabled]="readOnly ? '' : null"
               required=""
               [(ngModel)]="project.customer.customer_City" #customer_City="ngModel" />
      </div>
      <div class="d-flex control-wrapper" style="width: 115px;">
        <span class="warning">* </span>
        <select name="customer_State" id="customer_State"
                class="form-control state-select select-bidit"
                [attr.disabled]="readOnly ? '' : null"
                required=""
                [(ngModel)]="project.customer.customer_State" #customer_State="ngModel">
          <option value="">-</option>
          <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
        </select>
      </div>
      <div class="control-wrapper d-flex">
        <span class="warning">* </span>
        <input type="text" name="customer_Postal" id="customer_Postal"
               class="form-control" style="width: 95%;"
               placeholder="Zip"
               [attr.disabled]="readOnly ? '' : null"
               required=""
               [(ngModel)]="project.customer.customer_Postal" #customer_Postal="ngModel" />
      </div>
    </div>
    <div [hidden]="!leadForm.submitted || (customer_Address1.valid && customer_City.valid && customer_State.valid && customer_Postal.valid)"
         class="alert alert-danger" i18n>Customer Address Required</div>
  </div>

  <div *ngIf="customer">
    <label class="control-wrapper" for="contact_ID" i18n>Contact</label>
    <div class="form-group form-inline row-cols-2">
      <div class="form-inline">
        <select name="contact_ID" id="contact_ID"
                class="form-control select-bidit mb-1"
                (change)="onContactChange()"
                required=""
                [attr.disabled]="readOnly ? '' : null"
                [(ngModel)]="project.contact_ID" #contact_ID="ngModel">
          <option *ngFor="let contact of customer.contacts" [value]="contact.contact_ID">{{contact.contact_FirstName}} {{contact.contact_LastName}}</option>
        </select>
      </div>
    </div>
  </div>

  <span class="warning">* </span>
  <label class="control-wrapper" for="contact_FirstName" i18n>Contact Name</label>
  <div class="form-group form-inline row-cols-2">
    <div class="form-inline">
      <input type="text" name="contact_FirstName" id="contact_FirstName"
             class="form-control" style="width: 95%"
             required=""
             placeholder="First Name"
             [attr.disabled]="readOnly ? '' : null"
             [(ngModel)]="project.customer.contact_FirstName" #contact_FirstName="ngModel" />
    </div>
    <div class="form-inline">
      <input type="text" name="contact_LastName" id="contact_LastName"
             class="form-control float-right" style="width: 95%"
             required
             placeholder="Last Name"
             [attr.disabled]="readOnly ? '' : null"
             [(ngModel)]="project.customer.contact_LastName" #contact_LastName="ngModel" />
    </div>
  </div>
  <div [hidden]="!leadForm.submitted || (contact_FirstName.valid && contact_LastName.valid)"
       class="alert alert-danger" i18n>Contact First and Last Name Required</div>
  <div colspan="form-group form-inline row-cols-2">
    <div class="form-inline">
      <span class="warning" i18n>* Either Phone #, Cell #, or Email address is required</span>
    </div>
  </div>
  <div class="form-group form-inline row-cols-2">
    <div class="form-inline">
      <label for="contact_Phone" i18n>Phone</label>
      <input type="text" name="contact_Phone" id="contact_Phone"
             class="form-control float-right" style="width: 95%"
             placeholder="(999) 999-9999" appPhoneMask
             [attr.disabled]="readOnly ? '' : null"
             [(ngModel)]="project.customer.contact_Phone" #contact_Phone="ngModel" />
    </div>
    <div class="form-inline">
      <label for="contact_Mobile" i18n>Cell</label>
      <input type="text" name="contact_Mobile" id="contact_Mobile"
             class="form-control float-right" style="width: 95%"
             placeholder="(999) 999-9999" appPhoneMask
             [attr.disabled]="readOnly ? '' : null"
             [(ngModel)]="project.customer.contact_Mobile" #contact_Mobile="ngModel" />
    </div>
  </div>
  <div class="form-group form-inline row-cols-2">
    <div class="form-inline">
      <label for="contact_Email" i18n>Email</label>
      <input type="text" name="contact_Email" id="contact_Email"
             placeholder="Email"
             class="form-control float-right" style="width: 95%"
             [attr.disabled]="readOnly ? '' : null"
             [(ngModel)]="project.customer.contact_Email" #contact_Email="ngModel" />
    </div>
    <div class="form-inline">
      <span class="warning">* </span>
      <label for="contactType_ID" i18n>Contact Type</label>
      <select name="contactType_ID" id="contactType_ID" class="form-control select-bidit"
              required
              [attr.disabled]="readOnly ? '' : null"
              [(ngModel)]="project.customer.contactType_ID" #contactType_ID="ngModel">
        <option [ngValue]="undefined">-</option>
        <option *ngFor="let contactType of contactTypes" [ngValue]="contactType.contactType_ID">{{contactType.contactType_Desc}}</option>
      </select>
      <div [hidden]="!leadForm.submitted || contactType_ID.valid"
           class="alert alert-danger" i18n>Enter a contact type</div>
    </div>
  </div>
  <div [hidden]="!leadForm.submitted || ((contact_Phone.value != null && contact_Phone.value != '') ||
                  (contact_Mobile.value != null && contact_Mobile.value != '') ||
                  (contact_Email.value != null && contact_Email.value != ''))"
       class="alert alert-danger" i18n>Contact Phone, Cell, or Email Required</div>
  <div class="form-group text-bidit-primary">
    <label for="customer_ID" class=" col-form-label" i18n>Job Address</label>
    <div class="form-inline">
      <span i18n>Same as Customer Address</span>
      <input type="checkbox" name="jobAddressCustom" class="bidit-switch-sm text-bidit-primary"
             [attr.disabled]="readOnly ? '' : null"
             [ngModel]="jobAddressCustom" (click)="onJobAddressCustomChanged($event)" />
      <span i18n>New Job Address</span>
    </div>
    <div *ngIf="jobAddressCustom" class="text-bidit-primary">
      <div *ngIf="project.quote_IsLead">
        <div class="form-group form-inline row-cols-2">
          <div>
            <input type="text" name="quote_Address1" id="quote_Address1"
                   class="form-control" style="width: 95%;"
                   [attr.disabled]="readOnly ? '' : null"
                   placeholder="Address 1"
                   [(ngModel)]="project.quote_Address1" #quote_Address1="ngModel" />
          </div>
          <div>
            <input type="text" name="quote_Address2" id="quote_Address2"
                   class="form-control" style="width: 95%"
                   placeholder="Address 2"
                   [attr.disabled]="readOnly ? '' : null"
                   [(ngModel)]="project.quote_Address2" #quote_Address2="ngModel" />
          </div>
        </div>
        <div class="form-group form-inline row-cols-3">
          <div>
            <input type="text" name="quote_City" id="quote_City"
                   class="form-control" style="width: 95%;"
                   placeholder="City"
                   [attr.disabled]="readOnly ? '' : null"
                   [(ngModel)]="project.quote_City" #quote_City="ngModel" />
          </div>
          <div style="width: 115px;">
            <select name="quote_State" id="quote_State"
                    class="form-control state-select select-bidit"
                    [attr.disabled]="readOnly ? '' : null"
                    [(ngModel)]="project.quote_State" #quote_State="ngModel">
              <option value="">-</option>
              <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
            </select>
          </div>
          <div>
            <input type="text" name="quote_Postal" id="quote_Postal"
                   class="form-control" style="width: 95%;"
                   placeholder="Zip"
                   [attr.disabled]="readOnly ? '' : null"
                   [(ngModel)]="project.quote_Postal" #quote_Postal="ngModel" />
          </div>
        </div>
      </div>
      <div *ngIf="!project.quote_IsLead">
        <div class="form-group form-inline row-cols-2">
          <div class="control-wrapper d-flex">
            <span class="warning">* </span>
            <input type="text" name="quote_Address1" id="quote_Address1"
                   class="form-control" style="width: 95%;"
                   [attr.disabled]="readOnly ? '' : null"
                   placeholder="Address 1"
                   required=""
                   [(ngModel)]="project.quote_Address1" #quote_Address1="ngModel" />
          </div>
          <div class="control-wrapper d-flex">
            <input type="text" name="quote_Address2" id="quote_Address2"
                   class="form-control" style="width: 95%"
                   placeholder="Address 2"
                   [attr.disabled]="readOnly ? '' : null"
                   [(ngModel)]="project.quote_Address2" #quote_Address2="ngModel" />
          </div>
        </div>
        <div class="form-group form-inline row-cols-3">
          <div class="control-wrapper d-flex">
            <span class="warning">* </span>
            <input type="text" name="quote_City" id="quote_City"
                   class="form-control" style="width: 95%;"
                   placeholder="City"
                   [attr.disabled]="readOnly ? '' : null"
                   required=""
                   [(ngModel)]="project.quote_City" #quote_City="ngModel" />
          </div>
          <div class="control-wrapper d-flex" style="width: 115px;">
            <span class="warning">* </span>
            <select name="quote_State" id="quote_State"
                    class="form-control state-select select-bidit"
                    [attr.disabled]="readOnly ? '' : null"
                    required=""
                    [(ngModel)]="project.quote_State" #quote_State="ngModel">
              <option value="">-</option>
              <option *ngFor="let state of states;  let i=index" [(ngValue)]="states[i]">{{state}}</option>
            </select>
          </div>
          <div class="control-wrapper d-flex">
            <span class="warning">* </span>
            <input type="text" name="quote_Postal" id="quote_Postal"
                   class="form-control" style="width: 95%;"
                   placeholder="Zip"
                   [attr.disabled]="readOnly ? '' : null"
                   required=""
                   [(ngModel)]="project.quote_Postal" #quote_Postal="ngModel" />
          </div>
        </div>
        <div [hidden]="!leadForm.submitted || (quote_Address1.valid && quote_City.valid && quote_State.valid && quote_Postal.valid)"
             class="alert alert-danger" i18n>Job Address Required</div>
      </div>
    </div>
  </div>
  <div class="form-group form-inline row-cols-lg-2">
    <div *ngIf="project.quote_IsLead; else quoteReadyBlock" class="control-wrapper">
      <label for="readyDate" class="col-form-label" i18n>Estimated Start Date</label>
      <div class="form-inline">
        <input id="readyDate" name="quote_ReadyDate" class="form-control narrow-input" matInput
               placeholder="mm/dd/yyyy"
               [matDatepicker]="readyPicker"
               [disabled]="readOnly"
               [(ngModel)]="project.quote_ReadyDate" #quote_ReadyDate="ngModel" />
        <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="readyPicker"></mat-datepicker-toggle>
        <mat-datepicker [disabled]="readOnly" #readyPicker></mat-datepicker>
      </div>
    </div>
    <ng-template #quoteReadyBlock>
      <div class="control-wrapper">
        <label for="readyDate" class="col-form-label" i18n>Estimated Start Date</label>
        <div class="form-inline">
          <input id="readyDate" name="quote_ReadyDate" class="form-control narrow-input" matInput
                 placeholder="mm/dd/yyyy"
                 [matDatepicker]="readyPicker"
                 [disabled]="readOnly"
                 [(ngModel)]="project.quote_ReadyDate" #quote_ReadyDate="ngModel" />
          <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="readyPicker"></mat-datepicker-toggle>
          <mat-datepicker [disabled]="readOnly" #readyPicker></mat-datepicker>
        </div>
      </div>
    </ng-template>
    <div *ngIf="project.quote_IsLead" class="control-wrapper">
      <span class="warning">* </span>
      <label for="leadDueDate" class="col-form-label" i18n>Lead Expiration Date</label>
      <div class="info-icon" i18n-matTooltip matTooltip="Date which lead must be resolved by"></div>
      <div class="form-inline">

        <input name="quote_LeadDueDate" class="form-control narrow-input" matInput
               placeholder="mm/dd/yyyy"
               [matDatepicker]="dueDatePicker"
               required=""
               [disabled]="readOnly"
               [(ngModel)]="project.quote_LeadDueDate" #quote_LeadDueDate="ngModel" />
        <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
        <mat-datepicker [disabled]="readOnly" #dueDatePicker></mat-datepicker>
      </div>
      <div [hidden]="!leadForm.submitted || quote_LeadDueDate.valid"
           class="alert alert-danger" i18n>Lead expiration Required</div>
    </div>
    <div *ngIf="project.quote_IsLead" class="control-wrapper">
      <label for="followUpReminder" class="col-form-label" i18n>Follow Up Reminder Date</label>
      <div class="info-icon" i18n-matTooltip matTooltip="Date which a reminder will be sent to assigned salesperson"></div>
      <div class="form-inline">
        <input name="quote_FollowUpReminder" class="form-control narrow-input" matInput
               placeholder="mm/dd/yyyy"
               [matDatepicker]="followUpReminderPicker"
               [disabled]="readOnly"
               [(ngModel)]="project.quote_FollowUpReminder" #quote_FollowUpReminder="ngModel" />
        <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="followUpReminderPicker"></mat-datepicker-toggle>
        <mat-datepicker [disabled]="readOnly" #followUpReminderPicker></mat-datepicker>
      </div>
    </div>
  </div>
  <div class="form-group form-inline row-cols-lg-2">
    <div class="control-wrapper">
      <span class="warning">* </span>
      <label for="leadSourceType_ID" class="col-form-label" i18n>Lead Source</label>
      <select name="leadSourceType_ID" id="leadSourceType_ID" class="form-control select-bidit"
              required=""
              [attr.disabled]="readOnly ? '' : null"
              [(ngModel)]="project.leadSourceType_ID" #leadSourceType_ID="ngModel">
        <option [ngValue]="undefined">-</option>
        <option *ngFor="let source of leadSourceTypes" [ngValue]="source.leadSourceType_ID">{{source.leadSourceType_Desc}}</option>
      </select>
      <div [hidden]="!leadForm.submitted || leadSourceType_ID.valid"
           class="alert alert-danger" i18n>Lead Source Required</div>
    </div>
    <div class="control-wrapper">
      <label for="quote_LeadSourceComments" class="col-form-label" i18n>Lead Source Comments</label>
      <input name="quote_LeadSourceComments" id="quote_LeadSourceComments" class="form-control" type="text"
             [attr.disabled]="readOnly ? '' : null"
             [(ngModel)]="project.quote_LeadSourceComments" #quote_LeadSourceComments="ngModel" />
    </div>
    <div *ngIf="project.quote_IsLead" class="control-wrapper">
      <span class="warning">* </span>
      <label for="quote_Probability" class="col-form-label" i18n>Probability</label>
      <div class="info-icon" i18n-matTooltip matTooltip="Confidence factor for lead"></div>
      <select name="quote_Probability" id="quote_Probability" type="text" class="form-control select-bidit"
              [attr.disabled]="readOnly ? '' : null"
              required=""
              [(ngModel)]="project.quote_Probability" #quote_Probability="ngModel">
        <option value="">-</option>
        <option value="H" i18n>High</option>
        <option value="M" selected i18n>Medium</option>
        <option value="L" i18n>Low</option>
      </select>
      <div [hidden]="!leadForm.submitted || quote_Probability.valid"
           class="alert alert-danger" i18n>Probability Required</div>
    </div>

  </div>
  <div *ngIf="project.quote_IsLead; else quoteTypeBlock" class="control-wrapper">
    <label for="jobType_ID" class="col-form-label" i18n>Job Type</label>
    <select name="jobType_ID" id="jobType_ID" class="form-control select-bidit"
            [attr.disabled]="readOnly ? '' : null"
            [(ngModel)]="project.jobType_ID" #jobType_ID="ngModel">
      <option [ngValue]="undefined">-</option>
      <option *ngFor="let jobType of jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
    </select>
  </div>
  <ng-template #quoteTypeBlock>
    <div class="control-wrapper">
      <span class="warning">* </span>
      <label for="jobType_ID" class="col-form-label" i18n>Job Type</label>
      <select name="jobType_ID" id="jobType_ID" class="form-control select-bidit"
              [attr.disabled]="readOnly ? '' : null"
              required=""
              [(ngModel)]="project.jobType_ID" #jobType_ID="ngModel">
        <option [ngValue]="undefined">-</option>
        <option *ngFor="let jobType of jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
      </select>
      <div [hidden]="!leadForm.submitted || jobType_ID.valid"
           class="alert alert-danger" i18n>Job Type Required</div>
    </div>

  </ng-template>
  <div class="control-wrapper">
    <span class="warning">* </span>
    <label for="quote_Name" class="col-form-label" i18n>Project Name</label>
    <input name="quote_Name" id="quote_Name" type="text" class="form-control"
           [attr.disabled]="readOnly ? '' : null"
           maxlength="50" required=""
           [(ngModel)]="project.quote_Name" #quote_Name="ngModel">
    <div [hidden]="!leadForm.submitted || quote_Name.valid"
         class="alert alert-danger" i18n>Enter a project name</div>
  </div>
  <div class="control-wrapper">
    <span class="warning">* </span>
    <label for="quote_AssignedTo" class="col-form-label" i18n>Salesperson</label>
    <mat-select multiple required name="quote_AssignedTo" id="quote_AssignedTo" style="width:350px;" class="form-control"
                [attr.disabled]="readOnly ? '' : null"
                [(value)]="project.assignmentEdit">
      <mat-option *ngFor="let salesPerson of salesPersons" [value]="salesPerson.id">{{salesPerson.lastName}}, {{salesPerson.firstName}}</mat-option>
    </mat-select>
    <div [hidden]="!leadForm.submitted || (project.assignmentEdit != null && project.assignmentEdit.length > 0)"
         class="alert alert-danger" i18n>Salesperson Required</div>
  </div>
  <div class="control-wrapper">
    <span class="warning">* </span>
    <label for="office_ID" class="col-form-label" i18n>Office</label>
    <select name="office_ID" id="office_ID" class="form-control select-bidit"
            required=""
            [attr.disabled]="readOnly ? '' : null"
            [(ngModel)]="project.office_ID" #office_ID="ngModel">

      <option [ngValue]="undefined">-</option>
      <option *ngFor="let office of offices" [ngValue]="office.office_ID">{{office.office_Name}}</option>
    </select>
    <div [hidden]="!leadForm.submitted || office_ID.valid"
         class="alert alert-danger" i18n>Office Required</div>
  </div>
  <div *ngIf="!project.quote_IsLead" class="form-group row">
    <div class="col-sm-12 form-inline">
      <div class="control-wrapper">
        <label for="quote_PaymentType_ID" class="col-form-label" i18n>Payment Type</label>
        <select name="quote_PaymentType_ID" id="quote_PaymentType_ID" class="form-control select-bidit"
                [attr.disabled]="readOnly ? '' : null"
                [(ngModel)]="project.quote_PaymentType_ID" #quote_PaymentType_ID="ngModel">

          <option [ngValue]="undefined">-</option>
          <option *ngFor="let paymentType of paymentTypes" [ngValue]="paymentType.paymentType_ID">{{paymentType.paymentType_Desc}}</option>
        </select>
      </div>
      <div class="control-wrapper">
        <label for="quote_PaymentTerm_ID" class="col-form-label" i18n>Payment Terms</label>
        <select name="quote_PaymentTerm_ID" id="quote_PaymentTerm_ID" class="form-control select-bidit"
                [attr.disabled]="readOnly ? '' : null"
                [(ngModel)]="project.quote_PaymentTerm_ID" #quote_PaymentTerm_ID="ngModel">

          <option [ngValue]="undefined">-</option>
          <option *ngFor="let paymentTerm of paymentTerms" [ngValue]="paymentTerm.paymentTerm_ID">{{paymentTerm.paymentTerm_Desc}}</option>
        </select>
      </div>
    </div>
  </div>

  <div *ngIf="readOnly == false" class="row mt-2">
    <div class="col-md-12">
      <div class="float-right">
        <button type="submit" name="submit" id="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
        <button type="button" class="btn btn-bidit-cancel" (click)="cancelEdit()" i18n>Cancel</button>
        <div [hidden]="!leadForm.submitted || leadForm.valid"
             class="alert alert-danger" i18n>
          Validation issues encountered.  Please review your entered information.
        </div>
      </div>
    </div>
  </div>
</form>
